﻿import $ from "jquery";
import FiconBase from "./FiconBase";
import ElementQueries from "ElementQueries";
import "Fancybox";

export default class FiconLightbox extends FiconBase {
	constructor() {
		super(...arguments);
	}

	static init(options) {
		super.init(options);

		$(document)
			.off("ccsBreakpointFired.ficon")
			.on("ccsBreakpointFired.ficon", ".ccs-fancybox-ficon", () => {
				const fb = $.fancybox.getInstance();
				fb && fb.update();
			});
	}

	create(event) {
		super.create(event);

		const _ = this,
			$section = _.$section,
			options = _.options;

		_.config = {
			content: $section,
			type: "html",
			baseClass: "ccs-fancybox-ficon",
			smallBtn: false,
			touch: false,
			trapFocus: !ccs_util.isMobile(),  //CCSDT-8782
			afterLoad(instance, current) {
				ElementQueries.init(`#${$section[0].id}`, options.breakpoints);
				current.$content.scrollTop($section.data("scroll"));
				_.triggerEvent("open");
			},
			afterShow(instance, current) {
				_.initBackGroundVideoAutoPlay();
			},
			beforeClose(instance, current) {
				$section.data("scroll", current.$content.scrollTop());
				_.suppressYoutubeAutoplay();
			},
			afterClose(instance, current) {
				$.ccsVideoPlayer.stopAllVideos();

				ElementQueries.detach($section[0]);
				_.triggerEvent("close");

			}
		};

		$section.find("img").one("load", _.update);
	}

	open() {
		$.fancybox.open(this.config);
	}

	close() {
		$.fancybox.close();
	}

	update() {
		const fb = $.fancybox.getInstance();
		fb && fb.update();
	}

	adjustSpin($section) {
		const $spin = $section.find(".ccs-cc-inline-spritespin");
		let timer;

		$section.one("ccsSpinResize", () => {
			$(document).on("onUpdate.ccs-fb", (e) => {
				clearTimeout(timer);

				timer = setTimeout(() => {
					if (!$section.is(":visible")) {
						return;
					}

					const sectionHeight = $section.height();
					const sectionWidth = $section.width();

					const controlHeight = $section.find(".ccs-cc-inline-toolbox").outerHeight(true);
					const titleHeight = $section.find(".ccs-cc-inline-section-title").outerHeight(true);

					const spinData = $spin.spritespin("data");
					const spinHeight = spinData.height;
					const spinWidth = spinData.width;
					const ratio = spinWidth / spinHeight;

					let targetHeight = sectionHeight - titleHeight - controlHeight;
					let targetWidth = targetHeight * ratio;

					if (targetWidth > sectionWidth) {
						targetWidth = sectionWidth;
						targetHeight = targetWidth / ratio;
					}

					$spin.parent().width(sectionWidth);

					$spin.spritespin({
						width: targetWidth,
						height: targetHeight
					});
				}, 50);
			});
		});

		$section.on("ccsSpinResize", this.update);
	}

	adjustMedia($section) {
		super.adjustMedia($section);

		$section.one("ccsGalleryLoad", e => {
			const gallery = e.gallery;
			const maxHeight = gallery.maxHeight;

			const $fancybox = $section.closest(".ccs-fancybox-container");
			const margin = $fancybox.find(".ccs-fancybox-button--close").height();
			const padding = $section.outerHeight() - $section.height();
			const offset = margin * 2 + padding;

			const resize = () => {
				setTimeout(() => {
					const wndHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
					const sectionHeight = wndHeight - offset;
					const titleHeight = $section.find(".ccs-cc-inline-section-title").outerHeight(true);
					const ribbonHeight = $section.find(".ccs-slick-slider").outerHeight(true);
					const targetHeight = sectionHeight - titleHeight - ribbonHeight;

					if (targetHeight < maxHeight) {
						gallery.maxHeight = targetHeight;
						gallery.resize();
					}
				}, 300);
			};

			$(document).on("ccsFicon", e => {
				if (e.action === "open") {
					resize();
				}
			});

			$(window).on("resize", () => {
				if ($section.is(":visible")) {
					resize();
				}
			});

			resize();
		});
	}

	adjustHotspots($section) {
		$(document).on("beforeClose.ccs-fb", (e, instance, current) =>
			current.$content.find(".ccs-hotspots-point").qtip("hide"));

		$section.on("click", e => $section.find(".ccs-hotspots-point").not(e.target).qtip("hide"));
	}

	adjustFeatures($section) {
		$section.one("ccsFicon", () => {
			const $slickContainer = $section.find(".ccs-cc-fc-items");
			if (!$slickContainer.length || !ccs_util.isMobile()) {
				return;
			}

			const fcWrapper = [];
			$slickContainer.on("init", e => fcWrapper.push($(e.target)));

			let timer;
			$(document).on("onUpdate.ccs-fb", (e) => {
				if (!$section.is(":visible")) {
					return;
				}

				clearTimeout(timer);

				timer = setTimeout(() => {
					fcWrapper.forEach($fc => $fc.ccsSlick("setPosition"));
				}, 200);
			});
		});
	}

	// CCSDT-6820, https://stackoverflow.com/q/8318264
	suppressYoutubeAutoplay() {
		if (ccs_util.isMobile()) {
			return;
		}

		this.$section
			.find("[data-video-url*='youtu']")
			.off(".ytFicon")
			.one("ccsPlayer.ytFicon", e1 => {
				var $video = $(e1.target);
				var $wrap = $video.children(".ccs-cc-inline-embedded-video-wrapper");
				var player = e1.player;

				if (player.mejs.options.type === "video/youtube") {

					$video
						.off(".ytFicon")
						.on("ccsPlayer.ytFicon", e2 => {
						if (e2.originalEvent.type === "canplay") {

							player.pause();

							if ($wrap.length) {
								$wrap.hide();

								$video.one("click.ytFicon", () => {
									player.play();
									$wrap.show();
								});
							}
						}
					});
				}
			});
	}

	/*CCSDT-8019 - "autoplay won't work in Safari and Chrome if any of parents of video tag have any DOM manipulation*/
	/*the explicit trigger required*/
	initBackGroundVideoAutoPlay() {
		const $section = this.$section;

		if (ccs_util.isMobile())
			return;

		const $bgVideos = $section.find(".ccs-cc-inline-feature-background").find("video");

		$bgVideos.each((i, video) => {
			video.play();
			video.muted = true;
		});
	}
}
